import Footer from "./footer.js";
export default Footer;